import type { DailyStreakDTO, StreakStepDTO, TimeWindowDTO } from '../types/dto'
import type { DailyStreak, DailyStreakStep, TimeWindow } from '../types/domain'
import { fromRewardSpecDTO, fromReceivedItemDTO } from './reward.mapper'

const fromStreakStepDTO = (dto: StreakStepDTO): DailyStreakStep => ({
  step: dto.step,
  reward: fromRewardSpecDTO(dto.rewardSpec),
  received: dto.receivedItem ? fromReceivedItemDTO(dto.receivedItem) : undefined
})

const fromTimeWindowDTO = (dto: TimeWindowDTO): TimeWindow => ({
  start: new Date(dto.start),
  end: new Date(dto.end)
})

export const fromDailyStreakDTO = (dto: DailyStreakDTO): DailyStreak => ({
  currentStep: dto.currentStep,
  lastLoginAt: dto.lastLoginAt ? new Date(dto.lastLoginAt) : undefined,
  lastBetAt: dto.lastBetAt ? new Date(dto.lastBetAt) : undefined,
  nextLoginWindow: dto.nextLoginWindow ? fromTimeWindowDTO(dto.nextLoginWindow) : undefined,
  nextBetWindow: dto.nextBetWindow ? fromTimeWindowDTO(dto.nextBetWindow) : undefined,
  steps: dto.steps.map(fromStreakStepDTO)
})
